module.exports = __webpack_public_path__ + "img/sm.0277768d.png";